import { render, staticRenderFns } from "./ProfilePoints.vue?vue&type=template&id=87167dc0"
import script from "./ProfilePoints.vue?vue&type=script&lang=js"
export * from "./ProfilePoints.vue?vue&type=script&lang=js"
import style0 from "./ProfilePoints.vue?vue&type=style&index=0&id=87167dc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports